/**
 * MPCI Local Dropdown Options - Part 2
 * Vessel, Party, Container fields
 */

// Vessel Ownership Indicator
export const VESSEL_OWNERSHIP = [
  { text: '1 - Transport for owner account', value: '1' },
  { text: '2 - Transport for another account', value: '2' },
  { text: '3 - Private transport', value: '3' }
]

// Vessel Power Type
export const VESSEL_POWER_TYPE = [
  { text: '1 - Diesel', value: '1' },
  { text: '2 - Diesel and electric', value: '2' },
  { text: '3 - Electric', value: '3' },
  { text: '4 - Liquid Propane Gas', value: '4' },
  { text: '5 - Petrol', value: '5' },
  { text: '6 - Petrol and electric', value: '6' },
  { text: '7 - Hydrogen', value: '7' },
  { text: '8 - Compressed Natural Gas', value: '8' },
  { text: '9 - Liquified Natural Gas', value: '9' }
]

// Party Type
export const PARTY_TYPE = [
  { text: 'CZ - Shipper (Consignor)', value: 'CZ' },
  { text: 'CN - Consignee or Endorsee', value: 'CN' },
  { text: 'NI - Notify Party', value: 'NI' },
  { text: 'N2 - Second Notify Party', value: 'N2' },
  { text: "CG - Shipping Line's Agent", value: 'CG' },
  { text: "DDR - Forwarding (Shipper's) Agent", value: 'DDR' },
  { text: 'DP - Delivery Agent', value: 'DP' },
  { text: 'COX - Payer on behalf of importer', value: 'COX' }
]

// Party Identification Type
export const PARTY_ID_TYPE = [
  { text: 'SP - Shipper', value: 'SP' },
  { text: 'ES - Establishment (TRN)', value: 'ES' },
  { text: 'UAE - UAE Resident', value: 'UAE' },
  { text: 'NON - NON UAE Resident', value: 'NON' }
]

// Container Size
export const CONTAINER_SIZE = [
  { text: '22G1 - 20ft Standard Dry', value: '22G1' },
  { text: '22G0 - 20ft Standard Dry (Food Grade)', value: '22G0' },
  { text: '25G1 - 20ft High Cube Dry', value: '25G1' },
  { text: '42G1 - 40ft Standard Dry', value: '42G1' },
  { text: '45G1 - 40ft High Cube Dry', value: '45G1' },
  { text: 'L5G1 - 45ft High Cube Dry', value: 'L5G1' },
  { text: '22R1 - 20ft Reefer Standard', value: '22R1' },
  { text: '25R1 - 20ft Reefer High Cube', value: '25R1' },
  { text: '42R1 - 40ft Reefer Standard', value: '42R1' },
  { text: '45R1 - 40ft Reefer High Cube', value: '45R1' },
  { text: 'L5R1 - 45ft Reefer High Cube', value: 'L5R1' },
  { text: '22U1 - 20ft Open Top', value: '22U1' },
  { text: '22U6 - 20ft Open Top Hard Roof', value: '22U6' },
  { text: '42U1 - 40ft Open Top', value: '42U1' },
  { text: '42U6 - 40ft Open Top Hard Roof', value: '42U6' },
  { text: '22P1 - 20ft Flat Rack Fixed Ends', value: '22P1' },
  { text: '22P3 - 20ft Flat Rack Collapsible', value: '22P3' },
  { text: '42P1 - 40ft Flat Rack Fixed Ends', value: '42P1' },
  { text: '42P3 - 40ft Flat Rack Collapsible', value: '42P3' },
  { text: '22T5 - 20ft ISO Tank', value: '22T5' },
  { text: '22T6 - 20ft ISO Tank GP', value: '22T6' },
  { text: '22T7 - 20ft Chemical Tank', value: '22T7' },
  { text: '22B0 - 20ft Dry Bulk', value: '22B0' },
  { text: '22B1 - 20ft Dry Bulk Type B1', value: '22B1' },
  { text: '42B0 - 40ft Dry Bulk', value: '42B0' },
  { text: '42B1 - 40ft Dry Bulk Type B1', value: '42B1' },
  { text: '22P0 - 20ft Platform', value: '22P0' }
]

// Container Load Status
export const CONTAINER_LOAD_STATUS = [
  { text: '1 - More than one quarter volume available', value: '1' },
  { text: '2 - More than half volume available', value: '2' },
  { text: '3 - More than three quarters volume available', value: '3' },
  { text: '4 - Empty', value: '4' },
  { text: '5 - Full', value: '5' },
  { text: '6 - No volume available', value: '6' },
  { text: '7 - Full mixed consignment', value: '7' },
  { text: '8 - Full single consignment', value: '8' },
  { text: '9 - Part load', value: '9' },
  { text: '10 - Part load mixed consignments', value: '10' },
  { text: '11 - Single invoiced load', value: '11' },
  { text: '12 - Multi invoiced load', value: '12' },
  { text: '13 - Full load multiple bills', value: '13' }
]

// VGM Unit
export const VGM_UNIT = [
  { text: 'KGM - Kilogram', value: 'KGM' },
  { text: 'LBR - Pound', value: 'LBR' }
]

// Establishment or Individual
export const ESTABLISHMENT_OR_INDIVIDUAL = [
  { text: 'ES - Establishment', value: 'ES' },
  { text: 'IN - Individual', value: 'IN' }
]

// Contact Level
export const CONTACT_LEVEL = [
  { text: 'CO - Company', value: 'CO' },
  { text: 'IN - Individual', value: 'IN' }
]

// Temperature Type
export const TEMPERATURE_TYPE = [
  { text: '1 - Storage temperature', value: '1' },
  { text: '2 - Transport temperature', value: '2' },
  { text: '3 - Cargo operating temperature', value: '3' },
  { text: '4 - Transport emergency temperature', value: '4' },
  { text: '5 - Transport control temperature', value: '5' },
  { text: '6 - Boiling point', value: '6' },
  { text: '7 - Temperature, recorded', value: '7' },
  { text: '8 - Self accelerating decomposition temperature', value: '8' },
  { text: '9 - Self accelerating polymerization temperature', value: '9' }
]

// Temperature Measurement Code (DG flashpoint — includes Kelvin)
export const TEMPERATURE_UNIT = [
  { text: 'KEL - Kelvin', value: 'KEL' },
  { text: 'CEL - Celsius', value: 'CEL' },
  { text: 'FAH - Fahrenheit', value: 'FAH' }
]

// Container temperature only (spec excludes Kelvin)
export const CONTAINER_TEMPERATURE_UNIT = [
  { text: 'CEL - Celsius', value: 'CEL' },
  { text: 'FAH - Fahrenheit', value: 'FAH' }
]

// Service Requirement Code
export const SERVICE_REQUIREMENT = [
  { text: '1 - Carrier loads', value: '1' },
  { text: '2 - Full loads', value: '2' },
  { text: '3 - Less than full loads', value: '3' },
  { text: '4 - Shipper loads', value: '4' },
  { text: '5 - To be delivered', value: '5' },
  { text: '6 - To be kept', value: '6' },
  { text: '7 - Transhipment allowed', value: '7' },
  { text: '8 - Transhipment not allowed', value: '8' },
  { text: '9 - Partial shipment allowed', value: '9' },
  { text: '10 - Partial shipment not allowed', value: '10' },
  { text: '11 - Partial shipment and/or drawing allowed', value: '11' },
  { text: '12 - Partial shipment and/or drawing not allowed', value: '12' },
  { text: '13 - Carrier unloads', value: '13' },
  { text: '14 - Shipper unloads', value: '14' },
  { text: '15 - Consignee unloads', value: '15' },
  { text: '16 - Consignee loads', value: '16' },
  { text: '17 - Exclusive usage of equipment', value: '17' },
  { text: '18 - Non exclusive usage of equipment', value: '18' },
  { text: '19 - Direct delivery', value: '19' },
  { text: '20 - Direct pick-up', value: '20' },
  { text: '21 - Request for delivery advice services', value: '21' },
  { text: '22 - Do not arrange customs clearance', value: '22' },
  { text: '23 - Arrange customs clearance', value: '23' },
  { text: '24 - Check container condition', value: '24' },
  { text: '25 - Damaged containers allowed', value: '25' },
  { text: '26 - Dirty containers allowed', value: '26' },
  { text: '27 - Fork lift holes not required', value: '27' },
  { text: '28 - Fork lift holes required', value: '28' },
  { text: '29 - Insure goods during transport', value: '29' },
  { text: '30 - Arrange main-carriage', value: '30' },
  { text: '31 - Arrange on-carriage', value: '31' },
  { text: '32 - Arrange pre-carriage', value: '32' },
  { text: '33 - Report container safety convention information', value: '33' },
  { text: '34 - Check seals', value: '34' },
  { text: '35 - Container must be clean', value: '35' },
  { text: '36 - Request for proof of delivery', value: '36' },
  { text: '37 - Request for Customs procedure', value: '37' },
  { text: '38 - Request for administration services', value: '38' },
  { text: '39 - Transport insulated under Intercontainer INTERFRIGO', value: '39' },
  { text: '40 - Transport mechanically refrigerated under Intercontainer', value: '40' },
  { text: '41 - Cool or freeze service, not under Intercontainer INTERFRIGO', value: '41' },
  { text: '42 - Transhipment overseas', value: '42' },
  { text: '43 - Station delivery', value: '43' },
  { text: '44 - Non station delivery', value: '44' },
  { text: '45 - Cleaning or disinfecting', value: '45' },
  { text: '46 - Close ventilation valve', value: '46' },
  { text: '47 - Consignment held for pick-up', value: '47' },
  { text: '48 - Refrigeration unit check', value: '48' },
  { text: '49 - Customs clearance at arrival country by carrier', value: '49' },
  { text: '50 - Customs clearance at departure country by carrier', value: '50' },
  { text: '51 - Heating for live animals', value: '51' },
  { text: '52 - Goods humidification', value: '52' },
  { text: '53 - Ensure load is secure', value: '53' },
  { text: '54 - Open ventilation valve', value: '54' },
  { text: '55 - Phytosanitary control', value: '55' },
  { text: '56 - Tare check by carrier', value: '56' },
  { text: '57 - Temperature check', value: '57' },
  { text: '58 - Weighing of goods', value: '58' },
  { text: '59 - Escort', value: '59' },
  { text: '60 - No escort', value: '60' },
  { text: '61 - Request for berthing services', value: '61' },
  { text: '62 - Request for planned berth consideration', value: '62' },
  { text: '63 - Request for inbound passing services through port area', value: '63' },
  { text: '64 - Request for outbound passing services through port area', value: '64' },
  { text: '65 - Neutral delivery', value: '65' },
  { text: '66 - Early delivery', value: '66' }
]

// Cargo Type
export const CARGO_TYPE = [
  { text: '1 - Documents', value: '1' },
  { text: '2 - Low value non-dutiable', value: '2' },
  { text: '3 - Low value dutiable consignment', value: '3' },
  { text: '4 - High value consignment consignment', value: '4' },
  { text: '9 - Containerized', value: '9' },
  { text: '13 - Liquid cargo', value: '13' },
  { text: '19 - Obnoxious', value: '19' },
  { text: '20 - Out of gauge', value: '20' },
  { text: '21 - Household goods and personal effects', value: '21' }
]

// Sealing Party Code
export const SEALING_PARTY = [
  { text: 'AA - Consolidator', value: 'AA' },
  { text: 'AB - Unknown', value: 'AB' },
  { text: 'AC - Quarantine agency', value: 'AC' },
  { text: 'CA - Carrier', value: 'CA' },
  { text: 'CU - Customs', value: 'CU' },
  { text: 'SH - Shipper', value: 'SH' },
  { text: 'TO - Terminal operator', value: 'TO' }
]

// Seal Type
export const SEAL_TYPE = [
  { text: '1 - Mechanical seal', value: '1' },
  { text: '2 - Electronic seal', value: '2' },
  { text: '3 - Air fresh vent seal', value: '3' }
]
